export default {
  firstName: '',
  email: '',
  countryCode: '',
  dialCode: '',
  phoneNumber: '',
  password: '',
  rePassword: ''
};